import m from 'mithril'
import Ad_collections from '../../models/Ad_collection'
import gradient_section from '../components/gradient_section'

import quote_bar from '../components/quote_bar'
const image_base = 'https://libraryofshortstories.s3.ap-southeast-2.amazonaws.com/small/'


const Page = {

    view: function (vnode) {

        return [
            m(ad_collections_display)

        ]
    }
}


const ad_collections_display = {
    view: vnode => {
        return [
            m('.page',
                m(gradient_section,
                    m('.max-700',

                        m('h1.default_h1', 'Strange Ads of the Past'),
                        m('h2.default_h2', 'The most interesting advertisements from 19th and 20th century magazines and newspapers.'),

                        m('.p-10'),
                    )
                ),
                m('.ad_collections',

                    Ad_collections.list
                        // { code: 'amazing', alt: 'A cover of Amazing Stories depicting a spaceship flying past a planet with a single large city.' },
                        // { code: 'weird', alt: 'A cover of Weird Tales ad_collection depicting a pair of eyes and hands cluthing a glass ball with vultures and a dead body inside.' },
                        // { code: 'bulletin', alt: 'A cover of The Bulletin Newspaper depicting a court with several officials looking angry at a literal Kangaroo' },
                        // { code: 'colliers', alt: 'A cover of Colliers Weekly depicting a man with a top hat and red scarf with a snowball whizzing by.' }
                        .map((mag, i) =>
                            [
                                m(quote_bar, { quote: { quote: '“' + mag.quote + '”' } }),
                                m('.ad_collection',

                                    m('a.remove_default_link_styling',
                                        {
                                            href: '/adcollection/' + mag.code
                                        },
                                        m('h2.my_link', mag.title),
                                        m('h3', mag.subtitle),
                                        m('.image',
                                            m('img', {
                                                src: image_base + 'ads_header_' + mag.code + '.jpg',
                                                // alt: mag.alt
                                            }),

                                            m('.border')
                                        ),

                                    ),
                                    m('.p-10')
                                )
                            ]
                        )
                )
            ),

        ]
    }
}

export default Page